if(document.querySelector('.modeloalto .popup'))
{



const popintegrar = document.querySelector('.modeloalto .popup .pop.integrar')
const popanalizar = document.querySelector('.modeloalto .popup .pop.analizar')
const popaccionar = document.querySelector('.modeloalto .popup .pop.accionar')
const fuerahover = document.querySelector('.modeloalto .circuloarriba .modelo img.imgmodelo')
const btnintegrar = document.querySelector('.modeloalto .circuloarriba .modelo .btnintegrar')
const btnanalizar = document.querySelector('.modeloalto .circuloarriba .modelo .btnanalizar')
const btnaccionar = document.querySelector('.modeloalto .circuloarriba .modelo .btnaccionar')




btnintegrar.addEventListener('mouseover', (e)=>{
    
    popintegrar.style.display = 'block'
    popanalizar.style.display = 'none'
    popaccionar.style.display = 'none'
    // console.log(e.target);
})

btnanalizar.addEventListener('mouseover', (e)=>{
    popintegrar.style.display = 'none'
    popanalizar.style.display = 'block'
    popaccionar.style.display = 'none'
    // console.log(e);
})

btnaccionar.addEventListener('mouseover', (e)=>{
    popintegrar.style.display = 'none'
    popanalizar.style.display = 'none'
    popaccionar.style.display = 'block'
    // console.log(e);
})

fuerahover.addEventListener('mouseleave', (e) => {
    popintegrar.style.display = 'none'
    popanalizar.style.display = 'none'
    popaccionar.style.display = 'none'
    // console.log('lke');
})
}